import api from './api';

export const getActiveResolutionTypes = async () => {
  const response = await api.get('/api/private/resolution-types');
  return response.data;
};

export const getAdminResolutionTypes = async () => {
  const response = await api.get('/api/private/resolution-types/admin', {
    params: { includeInactive: true },
  });
  return response.data;
};

export const createResolutionType = async (payload) => {
  const response = await api.post('/api/private/resolution-types', payload);
  return response.data;
};

export const updateResolutionType = async (id, payload) => {
  const response = await api.put(`/api/private/resolution-types/${id}`, payload);
  return response.data;
};

export const deleteResolutionType = async (id) => {
  await api.delete(`/api/private/resolution-types/${id}`);
};
